/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  $('.collapsible-message__link').on('click', function(e) {
    e.preventDefault();
    if ($(this).attr('aria-expanded') == 'false') {
      $(this).children('.collapsible-message__link-label').text('Hide');
      $(this).attr('aria-expanded', 'true');
      $('.collapsible-message__desc').attr('aria-hidden', 'false');
    } else {
      $(this).children('.collapsible-message__link-label').text('Show');
      $(this).attr('aria-expanded', 'false');
      $('.collapsible-message__desc').attr('aria-hidden', 'true');
    }
  });

})(jQuery);
